import { useContext } from 'react';
import { useQuery } from 'react-query';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { lenderKeys } from '../cache-keys/lenderKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_request_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

type ISearchLoanRequest = { loanApplicationID: string } | { lenderID: string };

function getCacheKey(search: ISearchLoanRequest) {
  if ('loanApplicationID' in search) {
    return applicationKeys.loanRequest({
      applicationID: search.loanApplicationID,
    });
  }
  return lenderKeys.loanRequest({
    lenderID: search.lenderID,
  });
}

function parseQueryKey(
  queryKey: ReturnType<typeof getCacheKey>
): loan_request_api.ISearchLoanRequest {
  const [type] = queryKey;

  switch (type) {
    case 'lender': {
      const [, lenderID] = queryKey;
      return { lenderID };
    }
    case 'loan application': {
      const [, loanApplicationID] = queryKey;
      if (!loanApplicationID) throw new Error('Missing applicationID');
      return { loanApplicationID };
    }
  }
}

export function useLoanRequests(searchID: ISearchLoanRequest) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = getCacheKey(searchID);
  return useQuery(
    cacheKey,
    queryFunction(loan_request_api.find(api), ({ queryKey }) =>
      parseQueryKey(queryKey)
    ),
    {
      enabled:
        state.user.token.length > 0 && Object.values(searchID)[0].length > 0,
    }
  );
}
